import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './reports.reducer';
import * as moment from 'moment';
import { ReportsFilter } from './reports.models';
import { DatesInterval } from '../../global/interfaces';
import { getYearsDropdownValues, getMonthsDropdownValues } from '../../global/dates';

export const selectReportsState = createFeatureSelector<State>('reports');

export const selectReportsOptions = createSelector(selectReportsState, (state: State) => state.options);

export const selectReportsAvailability = createSelector(selectReportsState, (state: State) => state.availability);

export const selectReportsVisited = createSelector(selectReportsState, (state: State) => state.visited);

export const selectReportsFilter = createSelector(selectReportsState, (state: State) => state.filter);

export const selectReportsYearFilter = createSelector(selectReportsFilter, (state?: ReportsFilter) => state ? state.year : undefined);

export const selectReportsMonthFilter = createSelector(selectReportsFilter, (state?: ReportsFilter) => state ? state.month : undefined);

export const selectReportsDate = createSelector(selectReportsFilter, (filter?: ReportsFilter) => {
  if (!filter || filter.year === undefined || filter.month === undefined) {
    return undefined;
  }

  return moment.utc({ year: filter.year, month: filter.month }).endOf('month').format('YYYY-MM-DD');
});

export const selectReportsDates = createSelector(selectReportsState, (state: State) => state.dates);

export const selectReportsDatesMin = createSelector(selectReportsDates, (dates?: DatesInterval) =>
  dates ? moment.utc(dates.min) : undefined
);

export const selectReportsDatesMax = createSelector(selectReportsDates, (dates?: DatesInterval) =>
  dates ? moment.utc(dates.max) : undefined
);

export const selectReportsYears = createSelector(
  selectReportsDatesMin,
  selectReportsDatesMax,
  (min?: moment.Moment, max?: moment.Moment) => getYearsDropdownValues(min, max)
);

export const selectReportsMonths = createSelector(
  selectReportsYearFilter,
  selectReportsDatesMin,
  selectReportsDatesMax,
  (year?: number, min?: moment.Moment, max?: moment.Moment) => getMonthsDropdownValues(year, min, max)

);
